import { Navigate, useParams, useLocation } from "react-router";

import { isAppScope } from "../../utils/scopeRouting";

/**
 * ScopeValidator - Validates URL pattern and redirects legacy URLs.
 *
 * Admin is a valid first-class scope and does not use an id segment.
 * Legacy trial URLs like /NCT123/... still redirect to /trial/NCT123/...
 */
export default function ScopeValidator({
  children,
}: {
  children: React.ReactNode;
}) {
  const params = useParams();
  const location = useLocation();

  const scope = params.scope;

  if (scope && !isAppScope(scope)) {
    const legacyTrialId = scope;
    const pathParts = location.pathname.split("/").filter(Boolean);
    const restPath = pathParts.slice(1).join("/");
    const newPath = restPath
      ? `/trial/${legacyTrialId}/${restPath}`
      : `/trial/${legacyTrialId}`;

    return <Navigate to={newPath + location.search + location.hash} replace />;
  }

  return children;
}
